/**
 * An optimized H6 component.
 *
 * @param props
 * @returns h6
 */
export const H6: React.FC<JSX.IntrinsicElements["h6"]> = (props) => {
  return (
    <h6
      {...props}
      className={`text-[18px] leading-[24px] font-circular ${props.className}`}
    >
      {props.children}
    </h6>
  )
}
